module.exports = __webpack_public_path__ + "img/warning-s.732537d6.svg";